import React, { useEffect, useState } from 'react';
import Form from 'react-jsonschema-form';

const schema = {
  type: 'object',
  required: ['Nom'],
  properties: {
    Nom: { type: 'string' },
    SyncStatsAccountName: { type: 'string' },
    SyncStatsAccountId: { type: 'number' },
    DoliId: { type: 'string' },
    Appareils: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          telId: { type: 'string' },
          no: { type: 'number' },
          fonction: { type: 'string', enum: ['Telecommande', 'Camera'] },
        },
      },
    },
    Kits: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          no: { type: 'number' },
          Appareils: {
            type: 'array',
            items: {
              type: 'object',
              properties: {
                telId: { type: 'string' },
                no: { type: 'number' },
                fonction: { type: 'string', enum: ['Telecommande', 'Camera'] },
              },
            },
          },
        },
      },
    },
  },
};

const uiSchema = {
  Nom: { 'ui:title': 'Nom du client' },
  Appareils: { 'ui:title': 'Appareils', 'ui:options': { addable: true, removable: true } },
};

const ClientFormAdd = (props) => {
  function handleSubmit({ formData }) {
    fetch(process.env.REACT_APP_PROXY_HOST + '/liste/clients', {
      method: 'POST',
      body: JSON.stringify(formData),
      headers: { 'Content-Type': 'application/json' },
    })
      .then((res) => res.json())
      .then(() => {
        if (props.hasCommit) {
          props.hasCommit(true);
        }
      });
  }

  function log() {}

  return <Form schema={schema} uiSchema={uiSchema} onSubmit={handleSubmit} onError={log} />;
};

const ClientFormUpdate = (props) => {
  const [client, setClient] = useState({ ...(props.formData || {}) });
  const [dbid, setDbId] = useState(props.dbid);

  useEffect(() => {
    setClient({ ...(props.formData || {}) });
    setDbId(props.dbid);
  }, [props.formData, props.dbid]);

  function handleSubmit() {
    if (!dbid) {
      return;
    }
    fetch(process.env.REACT_APP_PROXY_HOST + '/liste/clients/' + dbid, {
      method: 'PUT',
      body: JSON.stringify(client),
      headers: { 'Content-Type': 'application/json' },
    });
  }

  function log() {}

  return <Form schema={schema} uiSchema={uiSchema} formData={client} onSubmit={handleSubmit} onError={log} />;
};

export { ClientFormAdd, ClientFormUpdate };



// WEBPACK FOOTER //
// src/components/clients/ClientForm.js